/** Inline SVG icons used by the Audio Player. */

export const PlayIcon = () => (
    <svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.1212 10.303L0 20.6061V10.303V0L12.1212 10.303Z" fill="white" />
    </svg>
)

export const PauseIcon = () => (
  <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="0" y="0" width="5" height="20" rx="1" fill="#ffffff" />
    <rect x="11" y="0" width="5" height="20" rx="1" fill="#ffffff" />
  </svg>
)

export const CopyIcon = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 8C8.449 8 8 8.449 8 9V15C8 15.551 8.449 16 9 16H15C15.552 16 16 15.551 16 15V9C16 8.449 15.552 8 15 8H9ZM9.333 0C10.804 0 12 1.196 12 2.667V6H15C16.654 6 18 7.346 18 9V15C18 16.654 16.654 18 15 18H9C7.346 18 6 16.654 6 15V12H2.667C1.196 12 0 10.804 0 9.333V2.667C0 1.196 1.196 0 2.667 0H9.333ZM9.333 2H2.667C2.299 2 2 2.299 2 2.667V9.333C2 9.701 2.299 10 2.667 10H6V9C6 7.346 7.346 6 9 6H10V2.667C10 2.299 9.701 2 9.333 2Z" fill="#0068F5" />
    </svg>
)
